export enum PreBindSignStatusEnum{
  WaitingSignature = 1,
  WaitingApproval = 2,
  Approved = 3,
  Rejected = 4,
  Failed = 5,
  Completed = 6
}
